import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const DepreciationsListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return <Common.Header title={t('depreciations.depreciations_title')}></Common.Header>;
};

export default translate()(DepreciationsListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/DepreciationsListHeader.js